import { queryOptions } from '@tanstack/react-query'

import { knockOutPublicFetcher } from '@/libs/fetcher/presets'

import type { PredictionNavNode } from './types'

export const predictionNavTreeLiveQueryKey = ['prediction', 'navigation-tree-live'] as const

interface NavTreeResponse {
  data: PredictionNavNode[]
}

/**
 * Curated Live 导航树（cdc-web `fetchNavigationTreeLive` / `useNavigationTreeLive`
 * 的移植）：`/api/v1/navigation-tree/live` 返回 flat L2 子分类节点（display_name /
 * icon_url / ordering / event_count，filter 为 `{live:'true', event_kind_groups}`）。
 *
 * 通用 nav-tree 里的 live 根是 sentinel 叶子（无 children），左侧栏数据源
 * 必须来自这里——live L1 选中时用它合成 children（All + 子分类）渲染侧栏。
 */
const fetchNavigationTreeLive = async (): Promise<PredictionNavNode[]> => {
  // 与普通 nav-tree 同款 fetcher 合约：successResponseDataProperty: '' 保留
  // 原始 {data} body（见 fetchNavigationTree）。
  const res = await knockOutPublicFetcher<NavTreeResponse>(
    '/api/v1/navigation-tree/live',
    undefined,
    { successResponseDataProperty: '' },
  )
  return res?.data ?? []
}

export function predictionNavTreeLiveQueryOptions() {
  return queryOptions({
    queryKey: predictionNavTreeLiveQueryKey,
    queryFn: fetchNavigationTreeLive,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 60 * 1000,
  })
}
